'use strict';

var React = require('react');
var Reflux = require('reflux');
var Router = require('react-router');

/* Actions */
var TeamActions = require('actions/team');
var ProjectActions = require('actions/project');
var DatasourceActions = require('actions/datasource');

/* Stores */
var TeamStore = require('stores/team');
var ProjectStore = require('stores/project');
var DatasourceStore = require('stores/datasource');
var LanguageStore = require('stores/language');

/* Components */
var Panel = require('components/ui/panel');
var ButtonGroup = require('components/ui/button-group');
var Button = require('components/ui/button');
var TextField = require('components/ui/text-field');
var AssignedUserList = require('./assigned-user-list');
var AssignedProjectList = require('./assigned-project-list');
var AssignedDatasourceList = require('./assigned-datasource-list');

var TeamDetails = React.createClass({
  displayName: 'TeamDetails',

  mixins: [Router.Navigation],

  getInitialState: function getInitialState() {

    if (!this.props.team) {
      this.props.team = {
        name: '',
        users: []
      };
    }

    var _props$team = this.props.team;
    var name = _props$team.name;
    var users = _props$team.users;
    var datasources = _props$team.datasources;
    var projects = _props$team.projects;

    return {
      name: name,
      users: users.map(function (user) {
        return Object.assign({}, user);
      }),
      datasources: datasources,
      projects: projects
    };
  },

  componentDidMount: function componentDidMount() {
    var component = this;

    var nameField = component.refs.nameField;

    if (nameField) {
      nameField.focus();
    }
  },

  render: function render() {
    var component = this;
    var props = this.props;
    var state = this.state;
    var create = props.create;
    var team = props.team;

    if (create) {
      return React.createElement(
        'form',
        { className: 'details-component team-details-component', onSubmit: component._onCreate },
        React.createElement(
          Panel,
          null,
          React.createElement(TextField, { ref: 'nameField', className: 'name-field', translationKey: 'team_details_name' }),
          React.createElement(
            ButtonGroup,
            null,
            React.createElement(Button, { translationKey: 'cancel', className: 'cancel', onClick: component._onCancel }),
            React.createElement(Button, { translationKey: 'create', type: 'submit' })
          )
        )
      );
    }

    if (!team) {
      return null;
    }

    var projects = ProjectStore.projects.filter(function (project) {
      return project.teams.some(function (assignedTeam) {
        return assignedTeam.teamId === team.id;
      });
    }).map(function (project) {
      return {
        id: project.id,
        name: project.name,
        role: project.teams.find(function (assignedTeam) {
          return assignedTeam.teamId === team.id;
        }).role
      };
    });

    var datasources = DatasourceStore.datasources.filter(function (datasource) {
      return datasource.teams.some(function (assignedTeam) {
        return assignedTeam.teamId === team.id;
      });
    }).map(function (datasource) {
      return {
        id: datasource.id,
        name: datasource.name,
        permission: datasource.teams.find(function (assignedTeam) {
          return assignedTeam.teamId === team.id;
        }).permission
      };
    });

    return React.createElement(
      'form',
      { className: 'details-component team-details-component', onSubmit: component._onSubmit },
      React.createElement(
        Panel,
        null,
        React.createElement(TextField, { ref: 'nameField', className: 'name-field', translationKey: 'team_details_name', value: team.name }),
        React.createElement(AssignedUserList, {
          users: state.users,
          onAssign: component._onAssignUser,
          onUnassign: component._onUnassignUser,
          onRoleChange: component._onUserRoleChange }),
        React.createElement(AssignedProjectList, {
          projects: projects,
          onAssign: component._onAssignProject,
          onUnassign: component._onUnassignProject,
          onRoleChange: component._onProjectRoleChange }),
        React.createElement(AssignedDatasourceList, {
          datasources: datasources,
          onAssign: component._onAssignDatasource,
          onUnassign: component._onUnassignDatasource,
          onPermissionChange: component._onDatasourcePermissionChange }),
        React.createElement(
          ButtonGroup,
          null,
          React.createElement(Button, { translationKey: 'cancel', className: 'cancel', onClick: component._onCancel }),
          React.createElement(Button, { translationKey: 'save', type: 'submit' }),
          React.createElement(Button, { translationKey: 'delete', onClick: component._onDelete, className: 'delete' })
        )
      )
    );
  },

  _onCancel: function _onCancel(evt) {
    if (evt) {
      evt.preventDefault();
    }

    this.transitionTo('/');
  },

  _onCreate: function _onCreate(evt) {
    evt.preventDefault();

    var component = this;
    var nameField = component.refs.nameField;

    var name = nameField.value;
    var users = component.state.users;

    TeamActions.create({ name: name, users: users });

    component.transitionTo('/');
  },

  _onDelete: function _onDelete() {
    if (confirm(LanguageStore.translate('team_details_delete_confirmation'))) {
      TeamActions['delete'](this.props.team.id);
    }
  },

  _onSubmit: function _onSubmit(evt) {
    evt.preventDefault();

    var component = this;
    var team = component.props.team;
    var nameField = component.refs.nameField;

    var name = nameField.value;
    var users = component.state.users;

    TeamActions.submit(team.id, { name: name, users: users });

    component.transitionTo('/');
  },

  _onAssignUser: function _onAssignUser(user) {
    var users = this.state.users.map(function (user) {
      return Object.assign({}, user);
    });
    users.push({ userId: user.id, role: 'reviewer' });
    this.setState({ users: users });
  },

  _onUnassignUser: function _onUnassignUser(user) {
    var users = this.state.users.filter(function (u) {
      return u.userId !== user.id;
    }).map(function (user) {
      return Object.assign({}, user);
    });
    this.setState({ users: users });
  },

  _onUserRoleChange: function _onUserRoleChange(userId, role) {
    TeamActions.changeUserRole(this.props.team.id, userId, role);
  },

  _onAssignProject: function _onAssignProject(project) {
    ProjectActions.assignTeam(project.id, this.props.team.id);
  },

  _onUnassignProject: function _onUnassignProject(project) {
    ProjectActions.unassignTeam(project.id, this.props.team.id);
  },

  _onProjectRoleChange: function _onProjectRoleChange(project, role) {
    ProjectActions.changeTeamRole(project.id, this.props.team.id, role);
  },

  _onAssignDatasource: function _onAssignDatasource(datasource) {
    DatasourceActions.assignTeam(datasource.id, this.props.team.id);
  },

  _onUnassignDatasource: function _onUnassignDatasource(datasource) {
    DatasourceActions.unassignTeam(datasource.id, this.props.team.id);
  },

  _onDatasourcePermissionChange: function _onDatasourcePermissionChange(datasourceId, permission) {
    // Noop for now
  }
});

module.exports = TeamDetails;


/** WEBPACK FOOTER **
 ** ../~/babel-loader!./js/components/team/details.js
 **/